import * as types from "@/store/customer/types";
import { customerExport } from "@/services/customer";

export default {
    async fetchCustomerExport({ commit }, payload) {
        try {
            const data = await customerExport(payload)
            commit(types.SET_CUSTOMERLIST, data.response);
            return data
        }
        catch (error) {
            throw error
        }
    },

  
};
